import { useTranslation } from 'next-i18next';
import { Fragment } from 'react';
import { InfoBoothComponentInterface } from '../../../../../interfaces/pagebuilder';
import { useSelector } from '../../../../../reduxToolkit/typedRedux';
import { BoothPopup } from '../../../templates/VystemLight/oneonone/BoothPopup';
import SmallBooth from '../../../templates/VystemLight/oneonone/SmallBooth';
import { PageBuilderSettingsSection, PageBuilderSettingsTable } from '../PageBuilderSettingsTable';

interface InfoBoothSettingsTableInterface {
  component: InfoBoothComponentInterface;
  onChange: (c: InfoBoothComponentInterface) => void;
}

const InfoBoothSettingsTable = ({ component, onChange }: InfoBoothSettingsTableInterface) => {
  const { t } = useTranslation(['pagebuilder']);

  const booths = useSelector((state) => state.common.booths);
  const event = useSelector((state) => state.common.event);

  const settingSections: PageBuilderSettingsSection[] = [
    {
      settings: [
        {
          label: t('pagebuilder:available-booths'),
          content: (
            <div
              style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
              }}>
              {booths.map((booth, index) => (
                <div className="m-4 relative">
                  <Fragment key={booth?._id + index}>
                    {event && (
                      <BoothPopup
                        booth={booth}
                        trigger={
                          <div id={`booth-${booth?._id}`} className="flex justify-center cursor-pointer" style={{ minWidth: '20%' }}>
                            <SmallBooth event={event} className="h-48" booth={booth} />
                          </div>
                        }
                      />
                    )}
                  </Fragment>
                  <div
                    style={{
                      position: 'absolute',
                      top: -10,
                      left: 0,
                      width: '100%',
                      height: '110%',
                      outline: booth?._id === component?.boothId ? '1px solid blue' : 'none',
                      zIndex: 20,
                    }}
                    onClick={() => {
                      let _component = { ...component };
                      if (component?.boothId != booth?._id)
                        _component = {
                          ...component,
                          boothId: booth._id,
                        };
                      else
                        _component = {
                          ...component,
                          boothId: '',
                        };

                      onChange(_component);
                    }}
                  />
                </div>
              ))}
            </div>
          ),
        },
      ],
    },
  ];

  return <PageBuilderSettingsTable sections={settingSections} onChange={onChange} component={component} />;
};
export default InfoBoothSettingsTable;
